<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="megse()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      [(ngModel)]="kereses"
      (ionInput)="szures()"
      [placeholder]="searchPlaceholder"
      debounce="120"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item
      button
      *ngFor="let item of szurt; trackBy: trackById"
      (click)="valaszt(item)"
      [color]="!multiple && isSelected(item.id) ? 'light' : ''"
    >
      <ion-checkbox
        *ngIf="multiple"
        slot="start"
        [checked]="isSelected(item.id)"
      ></ion-checkbox>
      <ion-icon
        *ngIf="!multiple && isSelected(item.id)"
        slot="start"
        name="checkmark-circle"
        color="success"
      ></ion-icon>
      <ion-label class="ion-text-wrap">
        {{ item.label }}
        <p *ngIf="item.sublabel">{{ item.sublabel }}</p>
      </ion-label>
    </ion-item>

    <ion-item *ngIf="truncated > 0" lines="none">
      <ion-label color="medium" class="ion-text-wrap">
        <i>További {{ truncated }} találat… finomíts a kereséssel.</i>
      </ion-label>
    </ion-item>

    <ion-item *ngIf="szurt.length === 0" lines="none">
      <ion-label color="medium"><i>Nincs találat.</i></ion-label>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer *ngIf="multiple" class="valaszto-lab">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" color="medium" (click)="megse()">Mégse</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <!-- Kitöltött gomb: a választást meg kell erősíteni, ez itt a művelet. -->
      <ion-button class="valaszto-kesz" fill="solid" color="primary" (click)="megerosit()">
        <ion-icon slot="start" name="checkmark-outline"></ion-icon>
        Kész<span *ngIf="selectedSet.size">&nbsp;({{ selectedSet.size }})</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
